<template>
    <v-list dense nav>
        <v-list-item
            v-for="(destination, index) in destinations"
            :key="index"
            :style="{backgroundColor: bgcolors[index]}"
        >
            <v-list-item-icon style="margin-right: 10px">
                <v-icon :color="colors[index]">mdi-checkbox-blank-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                {{ destination.destination_user_name }}
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
    export default {
        props: ['destinations', 'colors', 'bgcolors'],
        created: function () {
        }
    }

</script>

<style scoped>

</style>